import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useSearchParams } from 'react-router-dom';



export default function SigninPage() {
  
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect') || '/library';

  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    setLoading(false);
    if (error) return setError(error.message);
    window.location.href = redirectTo;
  }

  async function signInWithGoogle() {
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}${redirectTo}` }
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    }
  }

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center p-6 overflow-hidden">

      {/* --- BACKGROUND LAYERS --- */}
      {/* --- BACKGROUND LAYERS --- */}
       {/* Background is now global in App.tsx */}


      {/* ⭐ TAGLINE HEADING HERE ⭐ */}
      {/* <div className="text-center mb-8 select-none">
        <h2 className="font-[Instrument_Sans] text-white text-[28px] sm:text-[32px] font-medium tracking-wide">
          You need <span className="font-serif italic text-white font-light tracking-tighter ml-[-5px]">winners to win.</span>
        </h2>
      </div> */}


      {/* --- GLASS CARD --- */}
      <div className="text-white rounded-2xl p-[2px] bg-white/20 backdrop-blur-lg border border-white/20 shadow-xl">
        <div className="rounded-2xl w-[min(92vw,420px)] p-6 sm:p-8">

          {/* Header */}
          <div className="flex items-center gap-3 mb-2">
            <div className="w-9 h-9 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center">
              <img
                src="/lovable-uploads/obyect_new.svg"
                alt="Obyect Logo"
                className="w-6 h-6 object-contain"
              />
            </div>
            <h1 className="text-2xl font-semibold text-white drop-shadow-sm">Sign in</h1>
          </div>

          <p className="text-sm text-white/80 mb-4">Welcome to Obyect 👋</p>

          {/* Form */}
          <form onSubmit={onSubmit} className="grid gap-3">

            {/* Email */}
            <div>
              <label className="text-sm font-medium text-white/90">Email Address *</label>
              <input
                type="email"
                className="mt-1 w-full rounded-md border border-black/15 bg-white/5
                           px-3 py-2 text-sm text-white placeholder-white/40
                           outline-none focus:ring-2 focus:ring-white/40"
                placeholder="janedoe@example.com"
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
                required
              />
            </div>

            {/* Password */}
            <div>
              <label className="text-sm font-medium text-white/90">Password *</label>
              <input
                type="password"
                className="mt-1 w-full rounded-md border border-black/15 bg-white/5
                           px-3 py-2 text-sm text-white placeholder-white/40
                           outline-none focus:ring-2 focus:ring-white/40"
                placeholder="Enter your password"
                value={password}
                onChange={(e)=>setPassword(e.target.value)}
                required
              />
              <div className="mt-1 text-xs text-white/70">
                <a href="/auth/forgot-password" className="underline hover:text-white/90 transition-colors">
                  Forgot Password?
                </a>
              </div>
            </div>

            {/* Error */}
            {error && <p className="text-sm text-red-500">{error}</p>}

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="mt-1 h-11 rounded-md bg-black/90 text-white font-medium
                         hover:bg-white hover:text-black transition-colors disabled:opacity-60"
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>

            {/* Divider */}
            <div className="my-2 flex items-center gap-3 text-xs text-white/70">
              <span className="flex-1 h-px bg-white/25" />
              <span>OR</span>
              <span className="flex-1 h-px bg-white/25" />
            </div>

            {/* Google */}
            <button
              type="button"
              onClick={signInWithGoogle}
              disabled={loading}
              className="h-11 rounded-md border border-white/20 bg-white/10
                         font-medium flex items-center justify-center gap-2
                         text-white hover:bg-white hover:text-black transition-colors disabled:opacity-60"
            >
              <img src="https://www.svgrepo.com/show/475656/google-color.svg" className="w-5 h-5" alt="Google" />
              Sign In with Google
            </button>

            <p className="text-sm text-center mt-2 text-white/80">
              Don&apos;t have an account? <a className="underline hover:text-white" href="/auth/signup">Sign Up</a>
            </p>

            <div className="mt-6 text-[11px] text-white/70 text-center">
              © 2025 Obyect · 
              <a className="underline hover:text-white" href="/terms"> Terms of Service </a> · 
              <a className="underline hover:text-white" href="/privacy"> Privacy Policy </a>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
}
